import { render, staticRenderFns } from "./FormResultFrame.vue?vue&type=template&id=28509abf&scoped=true"
import script from "./FormResultFrame.vue?vue&type=script&lang=js"
export * from "./FormResultFrame.vue?vue&type=script&lang=js"
import style0 from "./FormResultFrame.vue?vue&type=style&index=0&id=28509abf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28509abf",
  null
  
)

export default component.exports